module.exports = __webpack_public_path__ + "sunsemweb/img/shh.fab7c9ce.png";